import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { LearningSectionLayoutJsonModel } from './learning-section-layout.json.model';

@Injectable({
  providedIn: 'root'
})
export class LearningSectionLayoutService extends BaseCollectionService<LearningSectionLayoutJsonModel, AppCollection> {
  protected ctor = LearningSectionLayoutJsonModel;
}
